import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Alert, Spinner } from 'reactstrap'

import Logo from '../../images/logo.png'
import LogoDark from '../../images/logo-dark.png'
import Head from '../../layout/head/Head'
import AuthFooter from './AuthFooter'
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard
} from '../../components/Component'
import { useGlobalStoreData } from '../../store/globalStore'
import { HOMEPAGE_URL } from '../../services/api-common'
import { unsubscribe } from '../../mailTemplate/src/services/B2BServices'

const Unsubscribe = () => {
  const { t } = useTranslation()

  const location = useLocation()

  const [isLoading, setIsLoading] = useState(false)
  const [isUnsubscribed, setIsUnsubscribed] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get('token')
  const from = searchParams.get('from')

  const languageGSD = useGlobalStoreData.language()

  const hasValidToken = !!token

  const handleUnsubscribe = async () => {
    setIsLoading(true)
    setErrorMessage(null)

    try {
      await unsubscribe(token)
      setIsUnsubscribed(true)
    } catch (error) {
      console.error('Unsubscribe error', error)
      setErrorMessage(t('unsubscribe.errorMessage'))
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancel = () => {
    window.location.href = `${HOMEPAGE_URL}/${languageGSD}/tradecalculus`
  }

  return (
    <>
      <Head title={t('unsubscribe.title')} />
      <Block className="nk-block-middle nk-auth-body wide-sm">
        <div style={{ borderRadius: '20px', overflow: 'hidden' }}>
          <PreviewCard className="card-bordered" bodyClass="card-inner-lg p-5">
            <div className="brand-logo pb-5 text-center">
              <Link to={`${HOMEPAGE_URL}/${languageGSD}/tradecalculus`} className="logo-link">
                <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
                <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
              </Link>
            </div>

          {!hasValidToken
            ? (
              <>
                <BlockHead>
                  <BlockContent>
                    <div className="text-center pb-2">
                      <Icon name="alert-circle" className="text-danger" style={{ fontSize: '64px' }} />
                    </div>
                    <BlockTitle tag="h5" className="text-center">{t('unsubscribe.title')}</BlockTitle>
                    <BlockDes className="text-center">
                      <p className="text-danger">{t('unsubscribe.invalidToken')}</p>
                    </BlockDes>
                  </BlockContent>
                </BlockHead>

                <div className="form-group">
                  <Button size="lg" className="btn-block" color="primary" onClick={handleCancel}>
                    {t('unsubscribe.backToHome')}
                  </Button>
                </div>
              </>
              )
            : !isUnsubscribed
                ? (
                <>
                  <BlockHead>
                    <BlockContent>
                      <BlockTitle tag="h4" className="text-center">{t('unsubscribe.title')}</BlockTitle>
                    </BlockContent>
                  </BlockHead>

                  {!!errorMessage && (
                    <div className="mb-3">
                      <Alert color="danger" className="alert-icon">
                        <Icon name="alert-circle" /> {errorMessage}
                      </Alert>
                    </div>
                  )}

                  <div className="text-center pb-4">
                    <p>{t('unsubscribe.confirmMessage')}</p>
                    {from && (
                      <p className="fw-bold mt-2">{from}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <Button
                      size="lg"
                      className="btn-block"
                      color="danger"
                      onClick={handleUnsubscribe}
                      disabled={isLoading}
                    >
                      {isLoading
                        ? <Spinner size="sm" color="light" />
                        : t('unsubscribe.confirmButton')}
                    </Button>
                  </div>
                  <div className="form-group">
                    <Button
                      size="lg"
                      className="btn-block"
                      color="light"
                      onClick={handleCancel}
                      disabled={isLoading}
                    >
                      {t('unsubscribe.cancelButton')}
                    </Button>
                  </div>
                </>
                  )
                : (
                <>
                  <BlockHead>
                    <BlockContent>
                      <div className="text-center pb-2">
                        <Icon name="check-circle" className="text-success" style={{ fontSize: '64px' }} />
                      </div>
                      <BlockTitle tag="h5" className="text-center">{t('unsubscribe.successMessage')}</BlockTitle>
                      <BlockDes className="text-center">
                        <p>{t('unsubscribe.description')}</p>
                      </BlockDes>
                    </BlockContent>
                  </BlockHead>

                  <div className="form-group">
                    <Button size="lg" className="btn-block" color="primary" onClick={handleCancel}>
                      {t('unsubscribe.backToHome')}
                    </Button>
                  </div>
                </>
                  )}
        </PreviewCard>
        </div>
      </Block>
      <AuthFooter />
    </>
  )
}

export default Unsubscribe
